export const REGIONS = [
	["Australia", -24.668163, 134.150929],
	["New Zealand", -41.837112, 172.793343],
	["United Kingdom", 54.260582, -1.979057],
	["United States of America", 39.999733, -98.678503],
	["Mexico", 22.77552, -102.57254],
	["Colombia", 3.374742, -74.8013],
	["Spain", 41.349148, -3.242865],
	["Argentina", -31.419014, -64.192828],
	["Peru", -9.788561, -75.516214],
	["Venezuela", 7.076774, -66.091605],
	["Chile", -34.572976, -71.095732],
	["Guatemala", 15.609342, -90.560029],
	["Ecuador", -1.519327, -78.356744],
	["Bolivia", -17.862018, -64.30772],
	["Cuba", 21.327181, -77.822863],
	["Dominican Republic", 18.892313, -70.086478],
	["Honduras", 14.504704, -87.225643],
	["Paraguay", -23.487637, -58.305235],
	["El Salvador", 13.539026, -88.912394],
	["Nicaragua", 12.139432, -84.908726],
	["Costa Rica", 9.641263, -83.917331],
	["Panama", 8.641033, -80.40586],
	["Uruguay", -33.242188, -56.011651],
	["Equatorial Guinea", 1.754489, 10.132435],
	["Democratic Republic of the Congo", -1.471684, 23.213382],
	["France", 46.263615, 2.178741],
	["Canada", 58.111966, -102.032381],
	["Madagascar", -19.863362, 46.526251],
	["Cameroon", 5.732121, 10.908544],
	["Côte d'Ivoire", 7.547363, -5.566505],
	["Niger", 9.513243, 8.089456],
	["Senegal", 14.502785, -14.654668],
	["Chad", 15.195064, 18.842802],
	["Guinea", 10.428156, -10.99111],
	["Rwanda", -2.002724, 30.010918],
	["Belgium", 50.615334, 4.524691],
	["Burundi", -3.409225, 29.974677],
	["Benin", 9.339155, 2.626981],
	["Haiti", 18.964026, -71.997441],
	["Switzerland", 46.910128, 8.416495],
	["Togo", 8.561699, 0.974885],
	["Central African Republic", 4.382328, 18.559633],
	["Congo", -0.22949, 15.935776],
	["Gabon", -1.343877, 11.721494],
	["Djibouti", 11.753348, 42.63842],
	["Comoros", -12.226076, 44.410906],
	["Luxembourg", 49.608384, 6.135195],
	["Vanuatu", -15.376706, 166.959158],
	["Seychelles", -4.677849, 55.467183],
	["Monaco", 43.73333, 7.41667],
	["Finland", 64.017562, 26.623533],
	["Sweden", 62.687783, 15.349523],
	["Åland", 60.546457, 19.947512],
	["Antigua and Barbuda", 17.060816, -61.796428],
	["The Bahamas", 50.467103, -3.542833],
	["Barbados", 13.169025, -59.555144],
	["Belize", 17.024106, -88.74177],
	["Botswana", -22.270514, 24.254831],
	["Dominica", 15.397731, -61.360261],
	["Eswatini", -26.564709, 31.501492],
	["Fiji", -17.792993, 177.984807],
	["The Gambia", 13.437437, -15.51614],
	["Ghana", 7.372686, -1.368372],
	["Grenada", 12.155863, -61.654958],
	["Guyana", 4.633369, -58.801275],
	["India", 23.041173, 78.891806],
	["Republic of Ireland", 53.422433, -7.929837],
	["Jamaica", 18.115368, -77.160905],
	["Kenya", 0.500765, 37.609136],
	["Kiribati", 2.002841, -157.391854],
	["Lesotho", -29.709284, 28.179611],
	["Liberia", 6.359217, -9.717986],
	["Malawi", -13.302212, 34.036726],
	["Malta", 35.948946, 14.413867],
	["Marshall Islands", 9.39583, 167.475819],
	["Federated States of Micronesia", 6.888581, 158.243484],
	["Namibia", -21.99025, 17.175129],
	["Nauru", -0.528747, 166.935421],
	["Nigeria", 9.513243, 8.089456],
	["Pakistan", 30.335127, 69.365084],
	["Palau", -5.095382, 159.404011],
	["Papua New Guinea", -6.269095, 143.940287],
	["Philippines", 14.435947, 121.024297],
	["Saint Kitts and Nevis", 17.315342, -62.744355],
	["Saint Lucia", 13.895288, -60.964518],
	["Saint Vincent and the Grenadines", 13.251501, -61.189064],
	["Samoa", -13.621469, -172.438935],
	["Sierra Leone", 8.516352, -11.852796],
	["Singapore", 1.304374, 103.82458],
	["Solomon Islands", -9.645712, 160.156195],
	["South Africa", -26.11617, 28.001226],
	["South Sudan", 4.852888, 31.6033],
	["Sudan", 15.641276, 32.531116],
	["Tanzania", -6.453096, 34.894539],
	["Tonga", -21.167665, -175.27284],
	["Trinidad and Tobago", 10.485968, -61.255908],
	["Tuvalu", -8.520721, 179.198109],
	["Uganda", 1.105402, 32.52062],
	["Zambia", -14.31191, 28.23479],
	["Zimbabwe", -19.16669, 29.516362],
	["Germany", 51.209439, 10.457347],
	["Austria", 47.648, 14.844832],
	["Liechtenstein", 47.160282, 9.540952],
	["South Tyrol", 46.672205, 11.159386],
	["Croatia", 45.334021, 15.738636],
	["Bosnia and Herzegovina", 44.12213, 18.11715],
	["Montenegro", 42.804508, 19.223085],
	["Serbia", 44.015665, 20.906401],
	["Poland", 52.129535, 19.394454],
	["Netherlands", 52.637082, 5.673591],
	["Suriname", 5.831058, -55.159137],
	["Greece", 38.894822, 22.431347],
	["Cyprus", 35.130126, 33.433356],
	["Akrotiri and Dhekelia", 35.130126, 33.433356],
	["Indonesia", -3.104976, 119.854142],
	["North Macedonia", 41.638192, 21.731396],
	["Turkey", 39.061415, 35.124582],
	["Sri Lanka", 7.517242, 80.779494],
	["Thailand", 15.660392, 101.520053],
	["Russia", 61.987429, 96.714855],
	["Belarus", 53.518236, 28.143867],
	["Kazakhastan", 47.827276, 67.382857],
	["Kyrgyzstan", 41.464025, 74.555223],
	["Tajikistan", 39.834832, 70.634386],
	["Algeria", 36.755589, 2.977719],
	["Bahrain", 25.995459, 50.588295],
	["Egypt", 26.561996, 31.688555],
	["Iraq", 33.139266, 42.802917],
	["Jordan", 31.12573, 36.392121],
	["Kuwait", 29.360775, 47.633578],
	["Lebanon", 34.191738, 35.887572],
	["Libya", 26.768524, 17.50665],
	["Mali", 12.646173, -8.001725],
	["Mauritania", 18.557723, -11.424025],
	["Morocco", 31.713478, -6.483976],
	["Oman", 20.022785, 56.381535],
	["State of Palestine", 33.295379, 44.322663],
	["Qatar", 25.525388, 51.217536],
	["Saudi Arabia", 24.638192, 46.710174],
	["Somalia", 5.432381, 47.079905],
	["Syria", 36.216663, 37.125963],
	["Tunisia", 36.79743, 10.181769],
	["United Arab Emirates", 25.269233, 55.307583],
	["Yemen", 15.744086, 47.66645],
	["Somaliland", 9.560553, 44.050861],
	["Zanzibar", -6.163746, 39.192246],
	["Sahrawi Arab Democratic Republic", -6.778218, 39.265474],
	["Japan", 35.672792, 136.690816],
	["Danish Realm", 54.479526, 10.118472],
	["South Korea", 36.458351, 127.855841],
	["North Korea", 39.930034, 126.549792],
	["China", 35.86002, 104.165802],
	["Taiwan", 23.709623, 120.543601],
	["Romania", 44.445441, 26.111523],
	["Moldova", 47.505003, 28.366633],
	["Transnistria", 46.846795, 29.60908],
	["Azerbaijan", 40.352954, 47.772974],
	["Dagestan", 42.980918, 47.499902],
	["Kosovo", 42.571109, 20.959413],
	["Italy", 42.672999, 12.592684],
	["San Marino", 43.936298, 12.445685],
	["Vatican City", 41.903148, 12.453801],
	["Czech Republic", 41.9041, 12.499711],
	["Vietnam", 13.318655, 108.3681],
	["Lithuania", 55.336438, 23.896703],
	["Hungary", 47.045058, 19.375867],
	["Slovenia", 46.138462, 14.987427],
	["Norway", 61.457979, 8.971401],
	["Bulgaria", 42.668565, 25.412718],
	["Brunei", 4.538105, 114.748453],
	["Malaysia", 3.101033, 101.627546],
	["Slovakia", 48.746119, 19.67294],
	["Vojvodina", 45.532663, 20.00334],
	["Latvia", 56.856496, 24.915373],
	["Ukraine", 48.907372, 31.722114],
	["Brazil", -9.683469, -52.308555],
	["Mozambique", -18.145428, 35.341997],
	["Angola", -12.286385, 17.762631],
	["Portugal", 39.306285, -8.003141],
	["East Timor", -8.819164, 125.865833],
	["Guinea-Bissau", 11.852992, -15.602996],
	["Macau", 45.009226, -0.612073],
	["Cape Verde", 16.004192, -24.009817],
	["São Tomé and Príncipe", 0.219483, 6.597725],
	["Estonia", 58.674419, 25.394371],
	["Iran", 32.815273, 53.487766],
	["Afghanistan", 33.828685, 65.658159],
] as const;

type Arc = {
	startLat: number;
	startLng: number;
	endLat: number;
	endLng: number;
	color: string;
};
export function generateArcsData(): Arc[] {
	let arcsData: Arc[] = [];
	for (let region of REGIONS) {
		const randomRegion = REGIONS[Math.round(Math.random() * (REGIONS.length - 1))];
		arcsData.push({
			startLat: region[1],
			startLng: region[2],
			endLat: randomRegion[1],
			endLng: randomRegion[2],
			color: "#dfad6c",
		});
	}
	return arcsData;
}

type Label = {
	lat: number;
	lng: number;
	text: string;
	color: string;
};
export function generateLablesData(): Label[] {
	let labelsData: Label[] = [];
	for (let region of REGIONS) {
		labelsData.push({
			lat: region[1],
			lng: region[2],
			text: region[0],
			color: "#ffffff",
		});
	}
	return labelsData;
}